module.exports = "<simple-crud service=\"vm.service\" translations=\"vm.translations\" fields=\"vm.fields\"></simple-crud>"


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/configurations/configurations.pug
// module id = 39
// module chunks = 0